import { Box, Button, Popover, Tooltip } from '@mui/material';
import React, { FocusEventHandler, useRef, useState } from 'react';
import { CompactPicker } from 'react-color';

export interface ColorPickerButtonProps {
  colorValue: string;
  onColorValueSubmit?: (color: string) => void;

  onBlur?: FocusEventHandler<HTMLButtonElement>;

  color?: 'inherit' | 'primary' | 'secondary';
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  buttonText?: string;

  buttonTooltip?: string;

  disabled?: boolean;
}

export const ColorPickerButton = (props: ColorPickerButtonProps) => {
  const {
    variant,
    size,
    color,
    colorValue,
    onColorValueSubmit,
    disabled,
    buttonText,
    buttonTooltip,
    onBlur,
  } = props;

  const buttonRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);

  const buttonJsx = (
    <Button
      ref={buttonRef}
      disabled={disabled}
      color={color}
      variant={variant}
      size={size}
      onBlur={onBlur}
      onClick={() => setOpen(true)}
    >
      <Box
        sx={{
          height: 22,
          width: 22,
          border: 'solid 1px black',
          borderRadius: (theme) => `${theme.shape.borderRadius}px`,
        }}
        style={{ backgroundColor: colorValue }}
      />
      {buttonText ? (
        <Box component="span" sx={{ marginLeft: 1 }}>
          {buttonText}
        </Box>
      ) : null}
    </Button>
  );
  return (
    <>
      {buttonTooltip != null && !disabled ? (
        <Tooltip title={buttonTooltip}>{buttonJsx}</Tooltip>
      ) : (
        buttonJsx
      )}
      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        anchorEl={buttonRef.current}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        slotProps={{ paper: { sx: { overflow: 'visible' }, elevation: 0 } }}
      >
        <CompactPicker
          color={colorValue}
          onChangeComplete={(color) => {
            if (onColorValueSubmit) {
              onColorValueSubmit(color.hex);
            }
            setOpen(false);
          }}
        />
      </Popover>
    </>
  );
};
